import { createI18n } from 'vue-i18n';
import { localeToReadableLanguageMap } from '@satellite/composables/useLocaleHelpers';

const messages = loadLocaleMessages();

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  availableLocales: Object.keys(localeToReadableLanguageMap),
  messages,
  modifiers: {
    pluralize: str => `${str}s`
  }
});

function loadLocaleMessages() {
  const messages = {};

  const coreLocales = import.meta.glob('@nova/core-locales/**/*.json', { eager: true });
  const satelliteLocales = import.meta.glob('@satellite/locales/**/*.json', { eager: true });
  const locales = import.meta.glob('@/locales/**/*.json', { eager: true });

  const allLocales = [
    ...Object.entries(coreLocales).map(([path, mod]) => ({ path, mod, isCore: true })),
    ...Object.entries(satelliteLocales).map(([path, mod]) => ({ path, mod, isCore: false })),
    ...Object.entries(locales).map(([path, mod]) => ({ path, mod, isCore: false }))
  ];

  for (const { path, mod, isCore } of allLocales) {
    const matched = path.match(/\/locales\/([a-zA-Z-]+)\/([a-zA-Z-]+)\.json$/);
    if (matched) {
      const locale = matched[1]; // e.g., 'en'
      const namespace = matched[2]; // e.g., 'common', 'createAppointment'

      messages[locale] = messages[locale] || {};

      if (isCore) {
        messages[locale].core = messages[locale].core || {};
        messages[locale].core[namespace] = mod.default;
      } else {
        messages[locale][namespace] = mod.default;
      }
    } else {
      console.warn('Unmatched locale path:', path);
    }
  }

  return messages;
}

export default i18n;
